import type { CourseModule } from "@/core/types";
import { lektionTabelleAnlegen } from "./lektion-01-tabelle-anlegen";
import { lektionStrukturierteVerweise } from "./lektion-02-strukturierte-verweise";
import { lektionErgebniszeile } from "./lektion-03-ergebniszeile";

export const modulTabellen: CourseModule = {
  id: "tabellen",
  title: "Tabellen und strukturierte Verweise",
  summary:
    "Der erste rote Faden: Tabelle statt Zellhaufen. Ein benanntes Objekt, das seine " +
    "Grenzen kennt, mitwächst und Formeln lesbar macht.",
  level: "Grundlagen",
  lessons: [lektionTabelleAnlegen, lektionStrukturierteVerweise, lektionErgebniszeile],
};
